import ProxyBase from '../../../../../core/proxies/ProxyBase'

class NewsAndSocialProxy extends ProxyBase {
  postBookmark(params) {
    return this.post('Bookmark', params)
  }

  deleteNewsBookmark(params) {
    return this.delete('Bookmark', params)
  }

  getNewsType(params) {
    return this.get('NewsType', params)
  }

  getSentiments(params) {
    return this.get('Sentiments', params)
  }

  getNewsAndSocials(params) {
    return this.post('NewsAndSocials', params)
  }
}

export default new NewsAndSocialProxy('News/')
